/**
 * Listing Content DOM Component
 *
 * Creates the scrollable content area of the listing sheet where
 * card plugins (floor plans, QMIs, etc.) render their grids.
 *
 * @module nativeInteractiveSiteMap/components/listingContent.dom
 */

export default function createListingContent() {
  const contentElement = document.createElement('div');
  contentElement.className = 'nhs-c-native-interactive-site-map__listing-content';

  return {
    getElement() {
      return contentElement;
    },
    remove() {
      contentElement.remove();
    },
  };
}
